/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateWalletOnePaymentMutationRequest, CreateWalletOnePaymentMutationResponse, CreateWalletOnePayment400, CreateWalletOnePayment401 } from "../entities/CreateWalletOnePayment";

function getCreateWalletOnePaymentUrl() {
  const res = { method: 'POST', url: `/api/v1/payments/wallet-one` as const }
  return res
}

/**
 * @description Создает новый платеж для платежной системы WalletOne.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 100 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Формирования формы заказа на стороне вебвью
 * 4. Отправка формы заказа в WalletOne API
 * 5. Возврат URL для оплаты
 * @summary Инициализация платежа для WalletOne
 * {@link /api/v1/payments/wallet-one}
 */
export async function createWalletOnePayment(data: CreateWalletOnePaymentMutationRequest, config: Partial<RequestConfig<CreateWalletOnePaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, CreateWalletOnePaymentMutationRequest>({ method : "POST", url : getCreateWalletOnePaymentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}